<template>
  <div class="header">
    <img class="logo" src="../assets/image/logo.png" alt="" />
    <div class="login">
      <div v-if="userInfo" class="user_icon" @click.stop="toggleOutModal" ref="excludeElementRef">
        <img class="loginok" src="../assets/image/login.png" />
        <img class="loginokquare" src="../assets/image/quare.png" />
      </div>
      <span class="loginbtn" v-else @click="login">登录</span>
    </div>
    <div
      class="loginfo"
      v-if="outis"
      v-click-outside="{ exclude: [excludeElementRef], handler: close }"
    >
      <p class="account">账号: {{ userInfo.nickname }}</p>
      <p class="out" @click="logout">
        <img src="../assets/image/logout.png" /> <span>退出登录</span>
      </p>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data() {
    return {
      outis: false,
      excludeElementRef: null,
    }
  },
  directives: {
    clickOutside: {
      bind(el, binding, vnode) {
        console.log(el)
        el.clickOutsideEvent = function (event) {
          // 检查点击是否在允许排除的元素中
          if (!binding.value.exclude.find((ref) => ref === event.target)) {
            // 如果不是，就执行指令绑定的回调函数
            binding.value.handler(event)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      },
    },
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  mounted() {
    this.excludeElementRef = this.$refs.excludeElementRef
  },
  methods: {
    ...mapActions(['setShowLoginModal', 'clearLoginStatus']),
    logout() {
      this.outis = false
      this.$emit('logout')
    },
    login() {
      this.setShowLoginModal(true)
    },
    toggleOutModal() {
      this.outis = !this.outis
    },
    close(ev) {
      console.log('ev', ev.target)
      this.outis = false
      return
    },
  },
}
</script>
<style lang="less" scoped>
@import '../assets/css/zIndex.less';

.header {
  position: fixed;
  left: 0;
  top: 0;
  z-index: @header_bar;
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  height: 78px;

  .logo {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    height: 46px;
  }

  .loginbtn {
    width: 92px;
    height: 32px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 30px;
    font-weight: 400;
    font-size: 20px;
    color: #ffffff;
    background-color: #07c261;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .login {
    position: absolute;
    right: 30px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    height: 40px;
  }
  .user_icon {
    position: relative;
    font-size: 0;
    .loginok {
      height: 40px;
    }
    .loginokquare {
      position: absolute;
      right: 0;
      bottom: -8px;
      transform: translateY(-50%);
      cursor: pointer;
      height: 17px;
    }
  }
  .loginfo {
    width: 249px;
    position: absolute;
    right: 32px;
    bottom: -120px;
    height: 138px;
    background: #ffffff;
    box-shadow: 0px 10px 25px 4px rgba(0, 0, 0, 0.18);
    border-radius: 10px;
    padding: 30px 13px;
    box-sizing: border-box;

    .account {
      font-weight: 400;
      font-size: 18px;
      color: #202226;
      text-align: center;
      border-bottom: 1px solid #d5d5d5;
      padding-bottom: 30px;
    }

    .out {
      font-weight: 400;
      font-size: 18px;
      color: #202226;
      display: flex;
      cursor: pointer;
      justify-content: center;
      margin-top: 20px;

      img {
        width: 20.3px;
        margin-right: 10px;
        height: 18px;
      }
    }
  }
}

@media (max-width: 1024px) {
  .header {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    height: 0.8rem;

    .logo {
      position: absolute;
      left: 0.16rem;
      top: 50%;
      transform: translateY(-50%);
      height: 0.5rem;
    }

    .loginbtn {
      width: 0.99rem;
      height: 0.44rem;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0.3rem;
      font-weight: 400;
      font-size: 0.24rem;
      color: #ffffff;
      background-color: #07c261;
      border-radius: 0.08rem;
      cursor: pointer;
      text-align: center;
    }

    .login {
      position: absolute;
      right: 0.3rem;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
      height: 0.4rem;
    }
    .user_icon {
      .loginok {
        height: 0.4rem;
      }
      .loginokquare {
        bottom: -0.08rem;
        height: 0.17rem;
      }
    }
    .loginfo {
      width: 3.55rem;
      position: absolute;
      right: 0.13rem;
      bottom: -1.87rem;
      height: 1.98rem;
      background: #ffffff;
      box-shadow: 0px 10px 25px 4px rgba(0, 0, 0, 0.18);
      border-radius: 0.1rem;
      padding: 0.4rem 0.18rem;
      box-sizing: border-box;

      .account {
        font-weight: 400;
        font-size: 0.26rem;
        color: #202226;
        text-align: center;
        border-bottom: 1px solid #d5d5d5;
        padding-bottom: 0.43rem;
      }
      .out {
        font-weight: 400;
        font-size: 0.26rem;
        color: #202226;
        display: flex;
        cursor: pointer;
        justify-content: center;
        margin-top: 0.32rem;
        img {
          width: 0.29rem;
          margin-right: 0.16rem;
          height: 0.26rem;
        }
      }
    }
  }
}
</style>
